import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React, { Component } from "react";

const styles = {
  card: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  section:{
    color:'#005458',
    fontWeight:'bold',
    paddingTop:10,
    paddingBottom:10,
    textDecoration:'underline'
    
  },
  listContainer:{
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.875rem',
    fontFamily: 'Noto Sans',
    fontWeight: '400',
    lineHeight: '1.5',
  }
};

class Privacy extends Component {

  state = {};
  componentWillMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { classes } = this.props;
    return (
      <Card className={classes.card}>
        <CardContent>

          <Typography variant="h5" component="h2">Privacy Policy</Typography>
          <Typography style={{marginLeft:0}} className={classes.pos} color="textSecondary">
            Last Updated : September 10, 2019
        </Typography>
          <Typography style={{
            color:'red'
          }} variant="h7" className={classes.section}component="h5">PLEASE READ THIS PRIVACY POLICY CAREFULLY.</Typography>
          <Typography variant="body2" component="p">
            Privacy is very important to NTRAC Inc. We also understand that privacy is very important
  to you. This Privacy Policy tells you how we protect and use information that we gather
  through the NTRAC website and NTRAC Application.
          </Typography>

          <Typography variant="body2" component="p">
            This Privacy Policy describes the types of information NTRAC may collect from you or that
  you may provide when you visit our website (novustrac.com) and use the NTRAC
  Application (the “NTRAC Platforms”). It also describes the type of information NTRAC may
  collect when you fill out a form or contact us through the NTRAC Platforms, and explains
  how we collect, use, maintain, protect, and, in some circumstances, disclose that information.
          </Typography>

          <Typography variant="body2" component="p">
            Certain information we collect is necessary to complete our contractual or legal obligations,
  other information is required for us to operate the NTRAC Platforms.
          </Typography>

          <Typography variant="body2" component="p">
            Please read this Privacy Policy carefully to understand NTRAC’s policies and practices
  regarding your information and how we will treat it. If you do not agree with NTRAC’s
  policies and practices, you may choose not to provide us with the requested information or to
  decline to use the NTRAC Platforms. By accessing or using the NTRAC Platforms, and/or by
  providing NTRAC with your information, you agree to this Privacy Policy.
          </Typography>

          <Typography variant="body2" component="p">
            We may change this Privacy Policy from time to time. We encourage you to review this
  Privacy Policy each time you visit the NTRAC Platforms.
          </Typography>

          <Typography variant="body2" component="p">
            By using the NTRAC Platforms, you agree to the terms of the most recent version of this
  Privacy Policy. Please read our Terms and Conditions to understand the general rules about
  your use of the NTRAC Platforms.
          </Typography>
          <Typography variant="h7" className={classes.section}component="h5">INTRODUCTION</Typography>
          <Typography variant="body2" component="p">
            The information we receive, and how we use it, depends on what you do when visiting the
  NTRAC Platforms and what information you provide to us. We collect and use your personal
  information differently than your non-personal information (information that is not
  identifiable to you personally).
          </Typography>
          <Typography variant="h7" className={classes.section}component="h5">INFORMATION WE COLLECT ABOUT YOU</Typography>
          <Typography variant="body2" component="p">
            NTRAC receives and stores information you enter on the NTRAC Platforms or give us in any
  other way. Examples of the information you may give NTRAC include:
          </Typography>
          <ul className={classes.listContainer}>
            <li>Information that you provide by filling in forms on the NTRAC Platforms, including messages you write to us</li>
            <li>Information you provide by signing up for our products and/or services</li>
            <li>Information you provide when you contact us through the NTRAC Platforms, by email, or in any other way. This includes records and copies of your correspondence,
as well as your postal and e-mail addresses</li>
            <li>Information you input about or relating to your farm</li>
          </ul>
          <Typography variant="body2" component="p">
            We use the information you provide for such purposes as responding to your requests,
  keeping you informed of news and information about NTRAC, customizing future visits to
  our site, improving the NTRAC Platforms or products, and communicating with you.
          </Typography>

          <Typography variant="body2" component="p">
            Some of this information can be considered personal information, which is information that
  can be used to specifically identify you, such as your name, telephone number, addresses, email address, username and password.
          </Typography>

          <Typography variant="body2" component="p">
            If you do not want us to have this information, you can choose not to provide it to us, but then
  you might not be able to take advantage of many of NTRAC’s services or features. See
  “What Are My Choices?”
          </Typography>

          <Typography variant="h7" className={classes.section}component="h5">HOW DOES NTRAC KEEP AND USE PERSONAL INFORMATION?</Typography>
          <Typography variant="body2" component="p">
            We may keep and use personal information we collect from you through the NTRAC
  Platforms to provide you with access to the NTRAC Platforms. In addition, NTRAC may
  keep and use your personal information to:
          </Typography>

          <ul className={classes.listContainer}>
            <li>Respond to your requests</li>
            <li> Personalize your access to the NTRAC Platforms, for example, by telling you about
new features that may be of interest to you</li>
            <li> Deliver the contents of the NTRAC Platforms correctly</li>
            <li> Develop records, including records of your personal information</li>
            <li> Contact you with information that might be of interest to you, including information
about products and services of ours and of others</li>
            <li> Use it to analyze, research, develop and improve programs, products, services and
content</li>
            <li> Enforce this Privacy Policy and other rules about your use of the NTRAC Platforms</li>
            <li> Protect our rights or property</li>
            <li> Protect someone’s health, safety or welfare</li>
            <li> Comply with a law or regulation, court order or other legal process</li>
            <li> Monitor and respond in case of a cyber attack</li>
            <li> Provide information to law enforcement authorities in the event of a cyber attack</li>
          </ul>
          <Typography variant="body2" component="p">
            In some instances, we de-identify or aggregate data by removing personal information (such
  as your name, e-mail address, etc.). Once de-identified or aggregated, the data is no longer
  attributed to a single unique individual. De-identified or aggregated information is nonpersonal information that we may treat like other non-personal information. If you would like
  to opt-out of the sale of your personal information as part of this de-identified and aggregated
  data, please contact us at support@novustrac.com.
          </Typography>
          <Typography variant="h7" className={classes.section}component="h5">DOES NTRAC EVER SHARE PERSONAL INFORMATION WITH THIRD PARTIES?</Typography>
          <Typography variant="body2" component="p">
            NTRAC values the personal information it has about its customers and is not in the business
  of selling it to others. However, we are occasionally required to share your information in
  order to conduct our business with you or to comply with legal obligations. Circumstances in
  which NTRAC may need to disclose collected personal information include:
          </Typography>
          <ul className={classes.listContainer}>
            <li> Disclosing to third parties we trust, and who are bound by contractual obligations to
  keep personal information confidential, to support our business (for example, our
  3
  accountants). In these circumstances, the third party will only use your personal
information for the purposes for which we disclose it to them</li>
            <li> Complying with any court order, law, legal process, or to responding to any
            government or regulatory request, including requests related to laws outside of your
country of residence</li>
            <li> Carrying out our obligations and enforcing our rights arising from any contracts
entered into between you and us</li>
            <li> Protecting the rights, property, or safety of NTRAC, its employees, customers, or
others</li>
            <li> Enforcing our terms and conditions</li>
            <li> Permitting us to pursue available remedies and/or limit the damages that we sustain</li>
            <li> Fulfilling our recordkeeping obligations and practices</li>
            <li> Fulfilling any other purpose disclosed by us when you provide the information</li>
            <li> Complying with your instructions</li>
          </ul>
          <Typography variant="body2" component="p">
            We may also need to provide the collected personal information to a buyer or other successor
  in the event of a merger, divestiture, restructuring, reorganization, dissolution, or other sale or
  transfer of some or all of NTRAC’s assets, whether as a going concern or as part of
  bankruptcy, liquidation, or similar proceeding, in which personal information held by
  NTRAC about its NTRAC Platforms’ users is among the assets transferred.
          </Typography>
          <Typography variant="h7" className={classes.section}component="h5">CREDIT CARD INFORMATION</Typography>
          <Typography variant="body2" component="p">
            In order to purchase our products and/or services, you will be asked to provide your credit
  card information. NTRAC does not collect your credit card information. Instead, the
  information is immediately transferred to our partner, Stripe, who processes the payment on
  our behalf. For more information about how Stripe collects and stores your information,
  please refer to Stripe’s privacy policy at https://stripe.com/privacy.
          </Typography>
          <Typography variant="h7" className={classes.section}component="h5">WHAT IS NON-PERSONAL INFORMATION?</Typography>
          <Typography variant="body2" component="p">
            “Non-Personal Information” is any information about you that does not reveal your specific
  identity, does not directly relate to an individual, and cannot be readily connected back to an
  individual such as:
          </Typography>
          <ul className={classes.listContainer}>
            <li> Demographic information and other similar information provided by you</li>
            <li> Marketing and Communications Data including your preferences in receiving
marketing from us and your communication preferences</li>
            <li> Your zip code, postal code or area code when they are not connected to other personal
information</li>
            <li> Aggregated information</li>
            <li> Personal information that has been de-identified</li>
          </ul>
          <Typography variant="h7" className={classes.section}component="h5">WHAT DOES NTRAC DO WITH NON-PERSONAL INFORMATION?</Typography>
          <Typography variant="body2" component="p">
            We will use non-personal information from you to help us make the NTRAC Platforms more
  useful to visitors. We also will use non-personal information for other business purposes. For
  example, we may use non-personal information or aggregate de-identified personal
  information to:
          </Typography>
          <ul className={classes.listContainer}>
            <li> Create reports for internal use</li>
            <li> Develop programs, products, services or content</li>
            <li> Customize the information or services that are of interest to you</li>
            <li> Share it with or sell it to third parties, unless you opt-out</li>
            <li> Provide aggregated “traffic statistics” and “response rates” to third parties.</li>
          </ul>
          <Typography variant="body2" component="p">
          We also de-identify or aggregate data by removing personal information (such as your name,
e-mail address, etc.). Once de-identified or aggregated, the data is no longer attributed to a
single unique individual. De-identified or aggregated information is non-personal information
that we may sell to third parties. 
          </Typography>
          <Typography variant="body2" component="p">
          You can always choose not to input your information, even though it might be needed to take
advantage of our services.           </Typography>
          <Typography variant="h7" className={classes.section}component="h5">WHAT CHOICES DO I HAVE?</Typography>
          <Typography variant="body2" component="p">
          If you would like to opt-out of the sale of your personal information as part of de-identified
and aggregated data, please contact us at support@novustrac.com.          </Typography>
          <Typography variant="body2" component="p">
          If you no longer want to receive e-mail or other mail from NTRAC, please press the
unsubscribe button on any of our e-mails or contact us at support@novustrac.com.          </Typography>
<Typography variant="h7" className={classes.section}component="h5">DOES NTRAC EVER COMMUNICATE DIRECTLY WITH VISITORS OF THE NTRAC
PLATFORMS?</Typography>

          <Typography variant="body2" component="p">
          If you provide us with your contact information through one of our contact forms or sign up
to use our products and services, we may contact you periodically by e-mail, mail or
telephone to provide information consistent with the information you request.           </Typography>
          <Typography variant="body2" component="p">
          In addition, some of the features on the NTRAC Platforms allow you to communicate with us
using an online form. If your communication requests a response from us, we will send you a
response via e-mail. The e-mail response or confirmation may include your personal
information. We cannot guarantee that our e-mails to you will be secure from unauthorized
interception.           </Typography>
          <Typography variant="body2" component="p">
          We may also contact you in cases where it is required by regulators to inform you of crucial
information about products updates.          </Typography>
<Typography variant="h7" className={classes.section}component="h5">ARE THERE SPECIAL RULES ABOUT CHILDREN'S PRIVACY?</Typography>
          <Typography variant="body2" component="p">
          NTRAC cares about protecting the online privacy of children. We will not intentionally
collect any personal information (such as a child’s name or e-mail address) from children
under the age of 13. If you think that we have collected personal information from a child
under the age of 13, please contact us at support@novustrac.com.           </Typography>

<Typography variant="h7" className={classes.section}component="h5">WHAT ABOUT WEBSITE SECURITY?</Typography>

          <Typography variant="body2" component="p">
          We secure the NTRAC Platforms and other systems through technical and organization
measures against the loss, destruction, access, amendment or distribution of your data by
unauthorized persons. You should keep in mind that no Internet transmission is ever 100% 
5
secure or error-free. In particular, e-mail sent to or from this site may not be secure, and you
should therefore take special care in deciding what information you send to us via e-mail.          </Typography>

<Typography variant="h7" className={classes.section}component="h5">CONTACT VIA THE NTRAC PLATFORMS</Typography>

          <Typography variant="body2" component="p">
          As required by law, the NTRAC Platforms contain information that provides a means of email contact to our company as well as other means of directly communicating with us. If
you contact us by e-mail or other electronic means, the personal data you transmit is stored
automatically. Such personal data will be stored for the purposes of responding to your
inquiry. This personal data will not be passed on to third parties.          </Typography>

<Typography variant="h7" className={classes.section}component="h5">HOW LONG DO YOU KEEP MY DATA?</Typography>

          <Typography variant="body2" component="p">
          In principle, we delete personal data when there is no requirement for further storage. A
requirement may exist, in particular, if the data is still needed in order to be able to fulfill
contractual obligations, to check warranty claims and, if applicable, guarantee claims and to
grant or defend them. In the case of statutory retention obligations, deletion is only
considered after the expiration of the respective retention period.          </Typography>

<Typography variant="h7" className={classes.section}component="h5">CAN I ACCESS, CORRECT OR DELETE MY DATA?</Typography>

          <Typography variant="body2" component="p">
          You may send us an e-mail at support@novustrac.com to request access to, correct, or delete
any personal information that you have provided to us. We may not accommodate a request
to access, change or delete information if we believe that doing so would violate any law or
legal requirement, cause the information to be incorrect, or if we are not legally obligated to
so. Deletion of your personal information may prevent you from using the NTRAC Platforms
or our other products and services          </Typography>
<Typography variant="h7" className={classes.section}component="h5">YOUR CALIFORNIA PRIVACY RIGHTS</Typography>


          <Typography variant="body2" component="p">
          California Civil Code Section § 1798.83 permits users of the NTRAC Platforms that are
California residents to request certain information regarding NTRAC’s disclosure of personal
information to third parties for their direct marketing purposes. To make such a request,
please send an e-mail to support@novustrac.com.          </Typography>

<Typography variant="h7" className={classes.section}component="h5">CHANGES TO OUR PRIVACY POLICY</Typography>


          <Typography variant="body2" component="p">
          It is NTRAC’s policy to post any changes it makes to its Privacy Policy on this page with a
notice that the Privacy Policy has been updated on the NTRAC Platforms’ home pages. If we
make material changes to how we treat our users’ personal information, we will notify you by
e-mail to the primary e-mail address specified in your account and/or through a notice on the
NTRAC Platforms’ home pages. The date the Privacy Policy was last revised is identified at
the top of the page. You are responsible for ensuring that we have an up-to-date, active, and
deliverable e-mail address for you, and for periodically visiting the NTRAC Platforms and
this Privacy Policy to check for any changes.          </Typography>

<Typography variant="h7" className={classes.section}component="h5">HOW DO I CONTACT YOU?</Typography>

          <Typography variant="body2" component="p">
          If you have questions or comments about this Privacy Policy, please use the Contact Us
feature at the top of your screen or by contacting NTRAC at:          </Typography>

          <Typography variant="body2" component="p">
          NTRAC<br/>
206 North Street<br/>
Hingham, MA 02043<br/>
Email: support@novustrac.com<br/>
Website: novustrac.com          </Typography>

          

        </CardContent>

      </Card>
    );
  }
}

export default withStyles(styles)(Privacy);



// WEBPACK FOOTER //
// ./src/components/public/Privacy.js